import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-searchbar',
    templateUrl: './searchbar.component.html',
    styleUrls: ['./searchbar.component.scss'],
    standalone: false,
})
export class SearchbarComponent {
    @Input()
    placeholder: string;

    @Input()
    searchText: string;

    @Output()
    searchTriggered: EventEmitter<string> = new EventEmitter<string>();

    constructor() {}

    initSearch(): void {
        this.searchTriggered.emit(this.searchText);
    }

    keyupEvent(event): void {
        if (event.code === 'Enter') {
            this.initSearch();
        }
    }
}
